import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  FaPaperclip,
  FaSmile,
  FaMicrophone,
  FaCamera,
  FaPaperPlane,
  FaTimes,
  FaStop,
  FaFilePdf,
  FaFileCsv,
  FaReply,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { FiFileText } from "react-icons/fi";
import { PiFileDocFill } from "react-icons/pi";
import EmojiPicker from "emoji-picker-react";
import Webcam from "react-webcam";
import { Button, TextInput } from "flowbite-react";
import axios from "axios";
import "./user-chat.css";
import { IoCaretBackCircleSharp } from "react-icons/io5";
import { IoIosSettings } from "react-icons/io";
import DeviceModal from "../../components/DeviceModal/DeviceModal";
import ModalPopup from "../../components/PopupModal/Modal";
import LoaderComponent from "../../components/Loader/LoaderComponent";
import { toast } from "react-toastify";
import BusinessCallPanel from "../../components/CallModal/BusinessCallPanel";
import { MdGroups } from "react-icons/md";

const ChatWindow = ({
  chat,
  setActiveChat,
  smallScreen,
  ShowSendingDiv,
  setConversationHistory,
  messageRefs,
  toggleSidePanel,
  IsAgentToAgent,
}) => {
  const ApiBaseURL = process.env.REACT_APP_GROUP_URL;
  const token = localStorage.getItem("authToken");
  const UserId = localStorage.getItem("accountId");
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const [file, setFile] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [recordedVideo, setRecordedVideo] = useState(null);
  const [isRecordingVideo, setIsRecordingVideo] = useState(false);
  const [isRecordingAudio, setIsRecordingAudio] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [messages, setMessages] = useState(chat.messages || []);
  const [lastChatNumber, setLastChatNumber] = useState("");
  const StartLoaderChatWindow = localStorage.getItem("StartLoaderChatWindow");

  const webcamRef = useRef(null);
  const audioRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const bottomRef = useRef(null);
  const isAgent = localStorage.getItem("isAgent") === "true";

  const [UploadSaveMediaUrl, setUploadSaveMediaUrl] = useState("");
  const [UploadMediaFileName, setUploadMediaFileName] = useState("");
  const [UploadMediaFileLiveUrl, setUploadMediaFileLiveUrl] = useState("");
  const [UploadMediaFileSaveName, setUploadMediaFileSaveName] = useState("");
  const [UploadMediaFileSavePath, setUploadMediaFileSavePath] = useState("");

  const [capturedImage, setCapturedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const [preDefineModal, setPreDefineModal] = useState(false);
  const [predefinedTemplates, setPredefinedTemplates] = useState([]);
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");
  const { Modal, handleOpen, handleClose } = ModalPopup();
  const [isLoading, setIsLoading] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState();
  const requestInProgress = useRef(false);

  const [userTemplateModal, setUserTemplateModal] = useState(false);
  const [userTemplates, setUserTemplates] = useState([]);
  const [userTemplateSearchQuery, setUserTemplateSearchQuery] = useState("");
  const [callInitiated, setCallInitiated] = useState(false);

  const isOlderChat = sessionStorage.getItem("olderChat");
  const isSpamChat = sessionStorage.getItem("spamChat");

  useEffect(() => {
    setMessages([]);
    setIsLoading(true);
  }, [chat.number]);

  useEffect(() => {
    const fetchChatMessages = async () => {
      if (requestInProgress.current) return;

      requestInProgress.current = true;
      if (StartLoaderChatWindow === "1") {
        setIsLoading(true);
      }
      try {
        const response = await axios.get(
          `${ApiBaseURL}WhatsappGroup/GetClickChatMessage?CustomerNumber=${chat.number}&SelectCheck=0&Message=&SessionID=${chat.id}&GroupId=${chat.groupId || 0}`);

        let apiData = response.data;

        // Remove duplicate WABA messages (within 2 minutes)
        if (chat.isGroup) {
          const uniqueMessages = [];

          apiData.forEach((msg) => {
            if (msg.sentfrom !== "WABA") {
              uniqueMessages.push(msg);
              return;
            }

            const currentTime = new Date(msg.inserttime).getTime();

            const alreadyExists = uniqueMessages.find((x) => {
              if (x.sentfrom !== "WABA") return false;

              const oldTime = new Date(x.inserttime).getTime();

              return (
                x.msgtext === msg.msgtext &&
                (x.FilePath || "") === (msg.FilePath || "") &&
                Math.abs(currentTime - oldTime) <= 2 * 60 * 1000 // 2 Minutes
              );
            });

            if (!alreadyExists) {
              uniqueMessages.push(msg);
            }
          });

          apiData = uniqueMessages;
        }

        // Transform the response
        const fetchedMessages =
          isAgent === true
            ? apiData.map((msg) => {
              const messageDate = new Date(msg.MessageTime);

              return {
                text: msg.MessageText,
                file: msg.Path,
                time: messageDate.toLocaleTimeString(),
                AgentCode: "",
                from: msg.MessageFrom === "A" ? "me" : "other",
                Date: `${messageDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}/${(messageDate.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}/${messageDate.getFullYear()}`,
                ReplyMsgText: "",
              };
            })
            : apiData.map((msg) => ({
              text: msg.msgtext,
              file: msg.FilePath,
              time: new Date(msg.inserttime).toLocaleTimeString(),
              AgentCode: msg.AgentCode,
              from: msg.sentfrom === "WABA" ? "me" : "other",
              Date: msg.DatePrint,
              ReplyMsgText: msg.ReplyMsgText,
              MobileNumber: msg.MobileNumber,
              ...msg,
            }));

        if (chat.number !== lastChatNumber) {
          setMessages(fetchedMessages);
          setLastChatNumber(chat.number);
        } else {
          if (fetchedMessages.length > messages.length) {
            setMessages(fetchedMessages);
          }
        }

        localStorage.setItem("StartLoaderChatWindow", "0");
      } catch (error) {
        console.error("Error fetching chat messages:", error);
      } finally {
        requestInProgress.current = false;
        setIsLoading(false);
      }
    };

    fetchChatMessages();

    // const intervalTime = isAgent ? 2000 : 2000;
    const intervalId = setInterval(() => {
      if (!requestInProgress.current) {
        fetchChatMessages();
      }
    }, 2000);

    return () => clearInterval(intervalId);
  }, [chat.number, messages.length, isAgent]);

  // Scroll to the bottom when messages change
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "instant" });
    }
  }, [messages]);

  useEffect(() => {
    if (messages) {
      const uniqueDates = Array.from(
        new Set(
          messages
            .map((msg) => {
              // Check if msg.Date is defined
              if (msg.Date) {
                const [day, month, year] = msg.Date.split("/"); // Split the date
                // Format to DD/MM/YYYY
                const formattedDate = `${day.padStart(2, "0")}/${month.padStart(
                  2,
                  "0"
                )}/${year}`;
                return formattedDate;
              }
              return "Invalid Date";
            })
            .filter((date) => date !== "Invalid Date") // Filter out invalid dates
        )
      );
      setConversationHistory(uniqueDates.map((date) => ({ date })));
    }
  }, [messages, setConversationHistory]);

  //Sending Normal Chat Message Api Calling And Show
  const handleSendMessage = async () => {
    // Don't proceed if a message is already being sent
    if (isSendingMessage) return;

    if (message.trim() || file || recordedVideo || audioURL) {
      // Set flag to true to indicate message is being sent
      setIsSendingMessage(true);

      // Create the payload for the API call
      const payload = {
        customerMobNo: chat.groupId,
        sendMessageText: message.trim(),
        sendFileName: UploadMediaFileName,
        sendFilePath: UploadMediaFileSavePath,
        sendFileURL: UploadMediaFileLiveUrl,
        agentNo: "",
        sendingSource: chat.msgFrom,
        sessionID: 0,
        isAgentToAgent: IsAgentToAgent,
        isAgent: isAgent
      };

      try {
        // Make the API call
        const wabaResponse = await axios.post(
          `${ApiBaseURL}WhatsappGroup/WABAChatAPI`,
          payload,
          {
            headers: {
              "Content-Type": "application/json"
            },
          }
        );
        if (wabaResponse.data === "Block Number") {
          toast.error("This number has OptOut.");
        } else if (
          wabaResponse.data === "SESSION_EXPIRED_OR_CHAT_TRANSFERRED"
        ) {
          toast.error("Chat has been transferred or the session has expired.");
        } else {
          if (UserId !== "MIM2400144") {
            const newMessage = {
              text: message.trim(),
              file: file ? UploadMediaFileLiveUrl : null,
              fileName: file ? file.name : null,
              video: recordedVideo,
              audio: audioURL,
              from: "me",
              sendingSource: chat.msgFrom,
              time: new Date().toLocaleTimeString(),
            };
            setMessages((prevMessages) => [...prevMessages, newMessage]);
          }
          clearInputFields();
        }
      } catch (error) {
        toast.error("Error sending message: ", error);
      } finally {
        // Reset flag after API response or error
        setIsSendingMessage(false);
      }
    }
  };

  const clearInputFields = () => {
    setMessage("");
    setFile(null);
    setRecordedVideo(null);
    setAudioURL(null);
    setUploadMediaFileName("");
    setUploadMediaFileSavePath("");
    setUploadMediaFileLiveUrl("");
  };

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileSizeMB = file.size / (1024 * 1024);

      // File size validation based on type
      if (
        ["jpg", "jpeg", "png", "gif"].includes(fileExtension) &&
        fileSizeMB > 5
      ) {
        toast.error("Image file size cannot exceed 5MB.");
        e.target.value = "";
        return;
      } else if (
        ["mp4", "mov", "avi", "mkv"].includes(fileExtension) &&
        fileSizeMB > 16
      ) {
        toast.error("Video file size cannot exceed 16MB.");
        e.target.value = "";
        return;
      } else if (
        ["mp3", "wav", "aac", "flac"].includes(fileExtension) &&
        fileSizeMB > 16
      ) {
        toast.error("Audio file size cannot exceed 16MB.");
        e.target.value = "";
        return;
      } else if (
        ["pdf", "doc", "docx", "html"].includes(fileExtension) &&
        fileSizeMB > 100
      ) {
        toast.error("Document file size cannot exceed 100MB.");
        e.target.value = "";
        return;
      } else if (
        chat.msgFrom !== 'w' && chat.msgFrom !== 'f' &&
        ["pdf", "doc", "docx", "html", "csv", "txt", "zip", "json", "exe", "xlsx"].includes(fileExtension)
      ) {
        toast.error("Document files not allowed");
        e.target.value = "";
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("file", file);
      setIsLoading(true);
      try {
        const response = await fetch(
          `${ApiBaseURL}WhatsappGroup/MediaFileUpload`,
          {
            method: "POST",
            headers: {
              accept: "*/*"
            },
            body: formData,
          }
        );

        if (!response.ok) {
          toast.error("Network response was not ok");
        }
        const result = await response.json();
        setUploadSaveMediaUrl(result.saveFileName || "");
        setUploadMediaFileName(result.filename || "");
        setUploadMediaFileLiveUrl(result.liveFilePath || "");
        setUploadMediaFileSaveName(result.saveFileName || "");
        setUploadMediaFileSavePath(result.saveFilePath || "");
        setFile(e.target.files[0]);
      } catch (error) {
        toast.error("Error : ", error);
      } finally {
        setIsLoading(false);
        e.target.value = "";
      }
    }
  };

  //HandleEmojis Messages
  const handleEmojiClick = (emojiObject) => {
    setMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleTemplateSearchChange = (e) => {
    setTemplateSearchQuery(e.target.value);
  };

  const handleCaptureImage = useCallback(async () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        setCapturedImage(imageSrc);
        setShowWebcam(false);
        setShowPreview(true);
      }
    }
  }, [webcamRef]);

  // Send Captured Image
  const handleSendCapturedImage = async () => {
    if (!capturedImage) return;

    try {
      const response = await axios.post(
        `${ApiBaseURL}WhatsappGroup/SaveCapturedMedia`,
        {
          base64Data: capturedImage,
          mediaType: "image",
          isAgent: false,
        },
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      const { liveFilePath, saveFilePath } = response.data; // Assuming response.data structure

      // Prepare payload for sending the captured image message
      const payload = {
        customerMobNo: chat.groupId,
        sendMessageText: "", // No text for image messages
        sendFileName: liveFilePath.substring(liveFilePath.lastIndexOf("/") + 1),
        sendFilePath: saveFilePath,
        sendFileURL: liveFilePath,
        agentNo: "",
        sessionID: 0,
        isAgentToAgent: IsAgentToAgent,
        isAgent: isAgent,
        sendingSource: chat.msgFrom
      };

      // Send payload to WABAChatAPI
      const wabaResponse = await axios.post(
        `${ApiBaseURL}WhatsappGroup/WABAChatAPI`,
        payload,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      if (wabaResponse.data === "Block Number") {
        toast.error("This number has OptOut.");
      } else if (wabaResponse.data === "SESSION_EXPIRED_OR_CHAT_TRANSFERRED") {
        toast.error("Chat has been transferred or the session has expired.");
      } else {
        setCapturedImage(null); // Clear captured image
      }
    } catch (error) {
      toast.error("Error sending captured image:", error);
    }
  };

  // Send Recorded Video
  const handleSendRecordedVideo = async () => {
    if (!recordedVideo) return; // Check if there's a recorded video

    // Convert blob URL back to a Blob object
    const response = await fetch(recordedVideo);
    const blob = await response.blob();

    // Convert Blob to Base64
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64data = reader.result;

      try {
        const saveResponse = await axios.post(
          `${ApiBaseURL}WhatsappGroup/SaveCapturedMedia`,
          {
            base64Data: base64data,
            mediaType: "video",
            isAgent: false,
          },
          {
            headers: {
              "Content-Type": "application/json"
            },
          }
        );

        const { liveFilePath, saveFilePath } = saveResponse.data; // Assuming response.data structure

        // Prepare payload for sending the captured video message
        const payload = {
          customerMobNo: chat.groupId,
          sendMessageText: "", // No text for video messages
          sendFileName: liveFilePath.substring(
            liveFilePath.lastIndexOf("/") + 1
          ),
          sendFilePath: saveFilePath,
          sendFileURL: liveFilePath,
          agentNo: "",
          sessionID: 0,
          isAgentToAgent: IsAgentToAgent,
          isAgent: false,
          sendingSource: chat.msgFrom
        };

        // Send payload to WABAChatAPI
        const wabaResponse = await axios.post(
          `${ApiBaseURL}WhatsappGroup/WABAChatAPI`,
          payload,
          {
            headers: {
              "Content-Type": "application/json"
            },
          }
        );
        if (wabaResponse.data === "Block Number") {
          toast.error("This number has OptOut.");
        } else if (
          wabaResponse.data === "SESSION_EXPIRED_OR_CHAT_TRANSFERRED"
        ) {
          toast.error("Chat has been transferred or the session has expired.");
        } else {
          const newMessage = {
            text: "",
            file: liveFilePath,
            from: "me",
            AgentCode: "",
            time: new Date().toLocaleTimeString(),
          };

          // Update local messages
          setMessages((prevMessages) => [...prevMessages, newMessage]);
          setRecordedVideo(null); // Clear recorded video
        }
      } catch (error) {
        toast.error("Error sending recorded video:", error);
      }
    };

    reader.readAsDataURL(blob); // Start reading the blob as data URL
  };

  const handleStartVideoRecording = useCallback(() => {
    setIsRecordingVideo(true);
    if (webcamRef.current && webcamRef.current.stream) {
      const mediaRecorder = new MediaRecorder(webcamRef.current.stream);
      let chunks = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: "video/webm" });
        setRecordedVideo(URL.createObjectURL(blob));
        chunks = [];
        setIsRecordingVideo(false);
      };

      mediaRecorder.start();
      webcamRef.current.mediaRecorder = mediaRecorder;
    }
  }, [webcamRef]);

  const handleStopVideoRecording = useCallback(() => {
    if (webcamRef.current && webcamRef.current.mediaRecorder) {
      webcamRef.current.mediaRecorder.stop();
    }
  }, [webcamRef]);

  const startAudioRecording = useCallback(() => {
    setIsRecordingAudio(true);
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;
        audioRef.current = stream;

        let chunks = [];
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.onstop = () => {
          const blob = new Blob(chunks, { type: "audio/ogg; codecs=opus" });
          setAudioURL(URL.createObjectURL(blob));
          chunks = [];
          setIsRecordingAudio(false);
        };

        mediaRecorder.start();
      })
      .catch((error) =>
        console.error("Error accessing the microphone:", error)
      );
  }, []);

  const stopAudioRecording = useCallback(() => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      audioRef.current.getTracks().forEach((track) => track.stop());
      setAudioURL(URL.createObjectURL(mediaRecorderRef.current.stream));
    }
  }, []);

  const handleSendAudio = async () => {
    if (!audioURL) return;

    try {
      // Fetch the audio blob from the URL
      const audioBlob = await fetch(audioURL).then((res) => res.blob());

      // Create a FormData object to send the audio file
      const formData = new FormData();
      formData.append("file", audioBlob, "audio.ogg");

      // Make the API call to save the audio
      const response = await axios.post(
        `${ApiBaseURL}WhatsappGroup/SaveCapturedMedia`,
        {
          base64Data: await blobToBase64(audioBlob),
          mediaType: "audio",
        },
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      // Process the response
      if (response.data) {
        const { liveFilePath, saveFilePath } = response.data;

        // Prepare payload for sending the captured video message
        const payload = {
          customerMobNo: chat.groupId,
          sendMessageText: "", // No text for video messages
          sendFileName: liveFilePath.substring(
            liveFilePath.lastIndexOf("/") + 1
          ),
          sendFilePath: saveFilePath,
          sendFileURL: liveFilePath,
          agentNo: "",
          sessionID: 0,
          isAgentToAgent: IsAgentToAgent,
          isAgent: false,
          sendingSource: chat.msgFrom
        };

        // Send payload to WABAChatAPI
        const wabaResponse = await axios.post(
          `${ApiBaseURL}WhatsappGroup/WABAChatAPI`,
          payload,
          {
            headers: {
              "Content-Type": "application/json"
            },
          }
        );

        if (wabaResponse.data === "Block Number") {
          toast.error("This number has OptOut.");
        } else if (
          wabaResponse.data === "SESSION_EXPIRED_OR_CHAT_TRANSFERRED"
        ) {
          toast.error("Chat has been transferred or the session has expired.");
        } else {
          const newMessage = {
            text: "",
            file: liveFilePath,
            from: "me",
            time: new Date().toLocaleTimeString(),
          };

          // Update local messages
          setMessages((prevMessages) => [...prevMessages, newMessage]);
          setAudioURL(null); // Clear the audio URL
        }
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      toast.error("Error sending audio: " + error.message);
    }
  };

  function formatFileName(fileName) {
    const parts = fileName.split(".");
    const extension = parts.pop(); // Get the file extension
    const name = parts.join("."); // Handle file names with multiple dots
    const slicedName = name.slice(0, 15); // Limit to 15 characters
    return `${slicedName}.${extension}`; // Reattach extension
  }

  // Helper function to convert blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey && !isSendingMessage) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const filteredMessages = messages.filter((msg) =>
    msg.text.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Function to handle sending predefined template
  const handleSendTemplate = async (templateName) => {
    try {
      const response = await axios.get(
        `${ApiBaseURL}WhatsappGroup/SendPreDefinedTemplate`,
        {
          params: {
            TemplateName: templateName,
            CustomerMobNo: chat.number,
            SessionId: 0,
            AgentNo: "",
            chatDate: "",
            isAgent: false,
          },
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      setPreDefineModal(false);
    } catch (error) {
      console.error("Error sending template:", error);
    }
  };

  const handleDeviceOpen = () => {
    if (currentTemplate) {
      handleOpen();
      setPreDefineModal(false);
    }
  };

  const filteredUserChatTemplate = userTemplates.filter((template) =>
    template.TemplateName.toLowerCase().includes(
      templateSearchQuery.toLowerCase()
    )
  );

  const handleUserTemplateSearchChange = (e) => {
    setUserTemplateSearchQuery(e.target.value);
  };

  // Function to handle sending predefined template
  const handleSendUserChatTemplateID = async (templateID) => {
    try {
      // Prepare payload for sending the captured video message
      const payload = {
        mapTemplateID: templateID.toString(),
        mobileNo: chat.number,
      };

      // Send payload to WABAChatAPI
      const Response = await axios.post(
        `${ApiBaseURL}WhatsappGroup/SendUserChatTemplateID`,
        payload,
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      setUserTemplateModal(false);
    } catch (error) {
      console.error("Error sending template:", error);
    }
  };

  return (
    <>
      <Modal>
        <DeviceModal
          templateId={currentTemplate?.TemplateID}
          handleClose={handleClose}
        />
      </Modal>
      <div className="w-full chat-window lg:w-2/3 md:w-1/2 sm:w-2/3 bg-white shadow-lg p-2 md:p-4 border rounded flex flex-col relative">
        {/* Card Header */}
        {smallScreen && (
          <div className="flex justify-between mb-2">
            <button
              className="flex gap-2 align-center"
              onClick={() => setActiveChat(null)}
            >
              <IoCaretBackCircleSharp className="mt-1" /> Back
            </button>
            <button
              className="bg-[#2c678d] p-1 rounded-lg"
              onClick={toggleSidePanel}
            >
              <IoIosSettings size={20} color="#ffffff" />
            </button>
          </div>
        )}
        <div className="bg-[#2c678d] text-white text-md font-medium rounded-lg p-2 mb-4 flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center gap-2">
            <MdGroups size={30} className="mt-1" />
            <span className="font-bold">
              {chat.name}
            </span>
          </div>
          <div className="w-full md:max-w-min flex flex-col-reverse md:flex-row justify-end align-center gap-2">
            {chat.msgFrom === "w" && (
              <IoCall
                onClick={() => setCallInitiated(true)}
                className="mt-2 mr-1"
                size={26}
                style={{ cursor: 'pointer' }}
                title="Start Call"
              />
            )}
            <TextInput
              type="text"
              placeholder="Search messages"
              id="msgSearch"
              value={searchQuery}
              onChange={handleSearchChange}
              className="min-w-80 mt-2 md:mt-0"
            />
          </div>
        </div>
        {/* Card Body */}
        <div className="overflow-y-auto flex-grow bg-gray-200 text-black p-2 relative">
          {isLoading ? (
            <LoaderComponent />
          ) : (
            <>
              {filteredMessages?.map((msg, index) => {
                const myMsg = msg.from === "me";
                const showDate =
                  index === 0 || msg.Date !== filteredMessages[index - 1].Date;
                return (
                  <div key={index}>
                    {showDate && (
                      <div
                        className="font-bold text-sm text-center mb-2"
                        ref={
                          msg.Date
                            ? (el) => {
                              messageRefs.current[msg.Date] = el;
                            }
                            : null
                        }
                      >
                        {msg.Date}
                      </div> // Render date header if needed
                    )}
                    <div>
                      <div
                        key={index}
                        className={`mb-2 ${myMsg ? "text-right" : ""}`}
                      >
                        <div
                          className={`msg-hover break-words whitespace-normal max-w-prose text-sm inline-block px-2 py-1 rounded relative ${myMsg
                            ? "bg-green-400 text-white text-left rounded-br-none"
                            : msg.ReplyMsgText
                              ? "bg-white text-black rounded-lg"
                              : "bg-white text-black rounded-bl-none"
                            }`}
                        >
                          {msg.file && (
                            <div className="mb-2">
                              {msg.file.endsWith(".pdf") && (
                                <a
                                  href={msg.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-2 underline"
                                >
                                  {<FaFilePdf size={40} />}
                                </a>
                              )}
                              {msg.file.endsWith(".csv") && (
                                <a
                                  href={msg.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-2 underline"
                                >
                                  {<FaFileCsv size={40} />}
                                </a>
                              )}
                              {msg.file.endsWith(".txt") && (
                                <a
                                  href={msg.file}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-2 underline"
                                >
                                  {<FiFileText size={40} />}
                                </a>
                              )}
                              {msg.file.endsWith(".doc") ||
                                (msg.file.endsWith(".docx") && (
                                  <a
                                    href={msg.file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-2 underline"
                                  >
                                    {<PiFileDocFill size={40} />}
                                  </a>
                                ))}
                              {msg.file.endsWith(".mp4") && (
                                <video
                                  className="max-w-xs"
                                  controls
                                  playsInline
                                  muted
                                >
                                  <source src={msg.file} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              )}
                              {msg.file.endsWith(".mp3") && (
                                <audio controls>
                                  <source src={msg.file} type="audio/ogg" />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              )}
                              {msg.file.endsWith(".ogg") && (
                                <audio controls>
                                  <source src={msg.file} type="audio/ogg" />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              )}
                              {/* Handle other video formats */}
                              {msg.file.endsWith(".webm") && (
                                <video
                                  className="max-w-xs"
                                  controls
                                  playsInline
                                  muted
                                >
                                  <source src={msg.file} type="video/webm" />
                                  Your browser does not support the video tag.
                                </video>
                              )}
                              {/* Handle other audio formats */}
                              {msg.file.endsWith(".wav") && (
                                <audio controls>
                                  <source src={msg.file} type="audio/wav" />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              )}
                              {/* Handle images */}
                              {!msg.file.endsWith(".pdf") &&
                                !msg.file.endsWith(".csv") &&
                                !msg.file.endsWith(".txt") &&
                                !msg.file.endsWith(".doc") &&
                                !msg.file.endsWith(".docx") &&
                                !msg.file.endsWith(".mp4") &&
                                !msg.file.endsWith(".mp3") &&
                                !msg.file.endsWith(".ogg") &&
                                !msg.file.endsWith(".webm") &&
                                !msg.file.endsWith(".wav") && (
                                  <div>
                                    <img
                                      className={`mt-2 ${msg["Button1"]
                                        ? "max-w-xs"
                                        : "max-w-xs md:max-w-sm"
                                        } max-h-60 rounded`}
                                      src={msg?.file}
                                    />
                                  </div>
                                )}
                            </div>
                          )}

                          {/* Video and audio from msg.video and msg.audio */}
                          {msg.video && (
                            <video
                              src={msg.video}
                              controls
                              className="mt-2 max-w-full h-auto rounded"
                            />
                          )}
                          {msg.audio && (
                            <audio
                              src={msg.audio}
                              controls
                              className="mt-2 max-w-full h-auto rounded"
                            />
                          )}
                          {msg.ReplyMsgText ? (
                            <div className="min-w-20 bg-gray-200 flex flex-col gap-1">
                              <p className="border shadow-sm bg-white px-2 py-1">
                                {msg.ReplyMsgText ? msg.ReplyMsgText : msg.text}
                              </p>
                              <p className="border-l-black border-4 px-2">
                                <span className="block text-xs font-semibold border-b-1">
                                  {chat.name}
                                </span>
                                {msg.ReplyMsgText ? msg.text : ""}
                              </p>
                            </div>
                          ) : (
                            <p
                              className={`${msg["Button1"] ? "max-w-xs" : ""}`}
                            >
                              {msg.text}
                            </p>
                          )}
                          {chat.groupId !== "" && msg.from !== "me" && msg.MobileNumber && (
                            <div className="text-xs font-semibold text-blue-600 mb-1">
                              {msg.MobileNumber}
                            </div>
                          )}
                          {msg["Button1"] &&
                            myMsg &&
                            (() => {
                              const buttons = Object.keys(msg).filter(
                                (key) =>
                                  key.startsWith("Button") &&
                                  !key.includes("Id") &&
                                  msg[key]
                              );
                              const buttonIds = Object.keys(msg).filter(
                                (key) =>
                                  key.startsWith("Button") &&
                                  key.includes("Id") &&
                                  msg[key]
                              );

                              return buttons.map((btn, index) => {
                                const buttonIdValue = msg[buttonIds[index]];

                                return (
                                  <button
                                    key={index}
                                    className="w-full flex gap-2 py-2 px-4 text-white justify-center items-center leading-none border-t mt-1"
                                  >
                                    {parseInt(buttonIdValue) >= 0 &&
                                      parseInt(buttonIdValue) < 9 ? (
                                      <FaReply size={16} />
                                    ) : buttonIdValue === "10" ? (
                                      <FaExternalLinkAlt size={16} />
                                    ) : buttonIdValue === "11" ? (
                                      <IoCall size={16} />
                                    ) : null}
                                    {msg[btn]}
                                  </button>
                                );
                              });
                            })()}
                        </div>
                        <div className="text-xs text-gray-500">
                          {msg.AgentCode && (
                            <span className="font-semibold text-red-500">
                              {" "}
                              ({msg.AgentCode}){" "}
                            </span>
                          )}
                          <span>{msg.time}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
          <div ref={bottomRef} />
        </div>
        {/* Card Footer */}
        {ShowSendingDiv ? (
          <div className="flex items-center mt-1 p-2 border rounded-full shadow-sm relative">
            {!audioURL && (
              <FaPaperclip
                className="text-[#2c678d] mx-2 cursor-pointer"
                onClick={() => document.getElementById("fileInput").click()}
                title="Attach file"
              />
            )}
            <input
              type="file"
              id="fileInput"
              className="hidden"
              onChange={handleFileChange}
            />
            {!audioURL && (
              <TextInput
                type="text"
                placeholder="Type message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                className="flex-grow border-none rounded-full"
                id="setMessage"
              />
            )}
            {file && (
              <div className="flex items-center ml-2">
                <span className="text-sm">{formatFileName(file.name)}</span>
                <FaTimes
                  className="text-red-500 ml-2 cursor-pointer"
                  onClick={() => setFile(null)}
                />
              </div>
            )}
            {audioURL && (
              <div className="w-3/4 flex items-center gap-2">
                <audio controls src={audioURL} className="flex-1 mr-2" />
                <button
                  onClick={handleSendAudio}
                  className="p-2 rounded hidden md:flex gap-2 items-center justify-center bg-green-700 text-white min-w-[140px] h-10 disabled:opacity-70"
                  disabled={isSendingMessage}
                >
                  {isSendingMessage ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      <span>Sending...</span>
                    </>
                  ) : (
                    <>
                      <FaPaperPlane
                        className="text-[#fff] mr-2 cursor-pointer"
                        onClick={handleSendMessage}
                        title="Send message"
                      />
                      Send Audio
                    </>
                  )}
                </button>
                <button
                  onClick={handleSendAudio}
                  className="p-2 rounded-full block md:hidden bg-green-700 w-10 h-10 flex items-center justify-center disabled:opacity-70"
                  disabled={isSendingMessage}
                >
                  {isSendingMessage ? (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin">Sending...</div>
                  ) : (
                    <FaPaperPlane
                      className="text-[#fff] cursor-pointer"
                      onClick={handleSendMessage}
                      title="Send message"
                    />
                  )}
                </button>
                <FaTimes
                  className="text-red-500 ml-2 cursor-pointer"
                  onClick={() => setAudioURL(null)}
                  title="Discard Audio"
                />
              </div>
            )}
            {!audioURL && (
              <div className="relative">
                {showEmojiPicker ? (
                  <FaTimes
                    className="text-[#2c678d] mx-2 cursor-pointer"
                    onClick={toggleEmojiPicker}
                    title="Close emoji picker"
                  />
                ) : (
                  <FaSmile
                    className="text-[#2c678d] mx-2 cursor-pointer"
                    onClick={toggleEmojiPicker}
                    title="Open emoji picker"
                  />
                )}
                {showEmojiPicker && (
                  <div className="absolute bottom-full right-0 p-2 rounded border-gray-300 max-h-60 overflow-y-auto scroll-hidden">
                    <div className="flex justify-end mb-2">
                      <FaTimes
                        className="text-[#2c678d] cursor-pointer"
                        onClick={toggleEmojiPicker}
                        title="Close emoji picker"
                      />
                    </div>
                    <div className="h-52 overflow-y-auto scroll-hidden">
                      <EmojiPicker onEmojiClick={handleEmojiClick} />
                    </div>
                  </div>
                )}
              </div>
            )}
            {!audioURL && (
              <>
                {isRecordingAudio ? (
                  <FaStop
                    className="text-red-500 mx-2 cursor-pointer"
                    onClick={stopAudioRecording}
                    title="Stop recording"
                  />
                ) : (
                  <FaMicrophone
                    className="text-[#2c678d] mx-2 cursor-pointer"
                    onClick={startAudioRecording}
                    title="Start recording"
                  />
                )}
                {isRecordingVideo ? (
                  <FaStop
                    className="text-red-500 mx-2 cursor-pointer"
                    onClick={handleStopVideoRecording}
                    title="Stop recording"
                  />
                ) : (
                  <FaCamera
                    className="text-[#2c678d] mx-2 cursor-pointer"
                    onClick={() => setShowWebcam(true)}
                    title="Start Camera"
                  />
                )}
              </>
            )}
            {!audioURL && (
              <>
                <button
                  type="button"
                  className={`bg-transparent p-0 border-0 text-[#2c678d] mx-2 flex items-center justify-center gap-1 ${isSendingMessage ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                  onClick={isSendingMessage ? undefined : handleSendMessage}
                  title="Send message"
                  aria-label="Send message"
                  disabled={isSendingMessage}
                >
                  {isSendingMessage ? (
                    <>
                      <div className="w-4 h-4 border-2 border-[#2c678d] border-t-transparent rounded-full animate-spin" />
                      <span className="text-sm">Sending...</span>
                    </>
                  ) : (
                    <FaPaperPlane />
                  )}
                </button>
              </>
            )}
          </div>
        ) : (
          <div className="text-center mt-1 p-2 text-red-600">
            <p>
              Use Send WhatApps Message Option to restart chat with this number.
            </p>
            <div className="text-center mt-1 p-2 text-blue-600">
              <p
                className="cursor-pointer hover:underline"
                onClick={() => setUserTemplateModal(true)}
                title="Click to reinitiate session"
              >
                Again Reinitiate the expired session
              </p>
            </div>
          </div>
        )}
        {showWebcam && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className="bg-white p-4 rounded shadow-lg"
              style={{ width: "36vw" }}
            >
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                className="w-full h-full"
              />
              <div className="flex justify-between mb-2">
                <Button onClick={handleCaptureImage} className="bg-green-500">
                  Capture Image
                </Button>
                {isRecordingVideo ? (
                  <Button onClick={handleStopVideoRecording} className="bg-red-500">
                    Stop Video
                  </Button>
                ) : (
                  <Button onClick={handleStartVideoRecording} className="bg-green-500">
                    Start Video
                  </Button>
                )}
                <Button onClick={() => setShowWebcam(false)} className="bg-red-500">
                  Close
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Preview for Captured Image */}
        {capturedImage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className="bg-white p-4 rounded shadow-lg"
              style={{ width: "36vw" }}
            >
              <img
                src={capturedImage}
                alt="Captured"
                className="max-w-full max-h-80"
              />
              <div className="flex justify-between mt-3">
                <Button onClick={handleSendCapturedImage} color="success">
                  Send Image
                </Button>
                <Button onClick={() => setCapturedImage(null)} color="failure">
                  Close Preview
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Preview for Recorded Video */}
        {recordedVideo && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div
              className="bg-white p-4 rounded shadow-lg"
              style={{ width: "36vw" }}
            >
              <video
                controls
                src={recordedVideo}
                className="max-w-full max-h-80"
              />
              <div className="flex justify-between mt-3">
                <Button onClick={handleSendRecordedVideo} color="success">
                  Send Video
                </Button>
                <Button onClick={() => setRecordedVideo(null)} color="failure">
                  Close Preview
                </Button>
              </div>
            </div>
          </div>
        )}
        {userTemplateModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center modal-index">
            <div className="bg-white p-4 rounded shadow-lg w-full md:w-3/4 lg:w-3/4 flex flex-col h-[80vh] overflow-y-auto relative">
              {/* Modal Header */}
              <div className="flex flex-col md:flex-row justify-between mb-4 mr-4">
                <h2 className="text-xl font-semibold">
                  Chat Reinitiate Templates Lists
                </h2>
                <div className="flex gap-2">
                  <TextInput
                    type="text"
                    placeholder="Search Template"
                    value={userTemplateSearchQuery}
                    onChange={handleUserTemplateSearchChange}
                    className="min-w-80 mt-2 md:mt-0"
                  />
                  <FaTimes
                    className="absolute top-2 right-2 cursor-pointer text-gray-500 hover:text-gray-700"
                    onClick={() => setUserTemplateModal(false)}
                  />
                </div>
              </div>
              {/* Modal Body */}
              <div className="flex-grow pb-10 overflow-y-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border px-4 py-2">Sr. No.</th>
                      <th className="border px-4 py-2">Template Name</th>
                      <th className="border px-4 py-2">Date</th>
                      <th className="border px-4 py-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUserChatTemplate[0] &&
                      filteredUserChatTemplate?.map((template, index) => (
                        <tr key={template.TemplateID}>
                          <td className="border px-4 py-2 text-center">
                            {index + 1}
                          </td>
                          <td className="border px-4 py-2">
                            {template.TemplateName}
                          </td>
                          <td className="border text-center px-4 py-2">
                            {template?.InsertDate.split(" ")[0]}
                          </td>
                          <td className="h-11 flex items-center gap-2 justify-evenly border px-4 py-2 text-center">
                            <FaPaperPlane
                              className="text-[#2c678d] cursor-pointer"
                              onClick={() =>
                                handleSendUserChatTemplateID(
                                  template.TemplateID
                                )
                              }
                              title="Send"
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {/* Modal Footer */}
              <div className="absolute bottom-0 left-0 right-0 flex justify-end p-2 border-t bg-white">
                <button
                  className="bg-[#2c678d] text-white px-4 py-2 rounded"
                  onClick={() => setPreDefineModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <BusinessCallPanel
        isVisible={callInitiated}
        setIsVisible={setCallInitiated}
        callerName={chat.name}
        callerMobileNumber={chat.number}
      />
    </>
  );
};

export default ChatWindow;
